import { usePopup } from '@/lib/PopupContext';
import { openChat } from '@/lib/chat';

export default function CTABanner({ title, subtitle, showChat = false }) {
  const { openPopup } = usePopup();

  return (
    <section className="relative py-20 md:py-28 overflow-hidden" data-testid="cta-banner">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1762638199646-ff8d7bd69baf?w=1920&q=80)' }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#002FA7]/90 via-[#002FA7]/85 to-[#001d6a]/80" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 text-center">
        <h2 className="font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-tight text-white mb-4 leading-tight">
          {title || 'Ready to Protect Your Brand?'}
        </h2>
        <p className="text-base md:text-lg text-white/80 font-body max-w-2xl mx-auto mb-8">
          {subtitle || 'Take the first step towards securing your trademark today. Our expert team is ready to guide you through every step of the process.'}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => openPopup()}
            className="bg-white text-[#002FA7] hover:bg-zinc-100 transition-colors px-8 py-4 font-bold text-sm tracking-widest uppercase"
            data-testid="cta-register-btn"
          >
            Register My Trademark
          </button>
          {showChat && (
            <button
              onClick={openChat}
              className="bg-transparent text-white hover:bg-white/10 transition-colors px-8 py-4 font-bold text-sm tracking-widest uppercase border border-white"
              data-testid="cta-chat-btn"
            >
              Chat Now
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
